(function () {
  const SELECTOR = '[data-gsr]';
  const initialized = new WeakSet();

  function initTabs(root) {
    const tabs = Array.from(root.querySelectorAll('[data-gsr-tab]'));
    if (tabs.length === 0) return;

    const setActive = (name) => {
      root.dataset.activeTab = name;
      tabs.forEach((t) => {
        t.setAttribute('aria-selected', t.dataset.gsrTab === name ? 'true' : 'false');
      });
    };

    tabs.forEach((tab, idx) => {
      tab.setAttribute('tabindex', tab.getAttribute('aria-selected') === 'true' ? '0' : '-1');

      tab.addEventListener('click', () => {
        setActive(tab.dataset.gsrTab);
        tabs.forEach((t) => t.setAttribute('tabindex', t === tab ? '0' : '-1'));
      });

      tab.addEventListener('keydown', (e) => {
        if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight' && e.key !== 'Home' && e.key !== 'End') return;
        e.preventDefault();
        let next = idx;
        if (e.key === 'ArrowLeft') next = idx === 0 ? tabs.length - 1 : idx - 1;
        if (e.key === 'ArrowRight') next = idx === tabs.length - 1 ? 0 : idx + 1;
        if (e.key === 'Home') next = 0;
        if (e.key === 'End') next = tabs.length - 1;
        tabs[next].focus();
        tabs[next].click();
      });
    });
  }

  function initVideoCards(root) {
    const cards = Array.from(root.querySelectorAll('[data-gsr-card]'));

    cards.forEach((card) => {
      const surface = card.querySelector('[data-gsr-play-inline]');
      const video = card.querySelector('[data-gsr-video]');
      if (!surface || !video) return;

      surface.addEventListener('click', (e) => {
        e.preventDefault();
        if (card.dataset.playing === 'true') return;

        card.dataset.playing = 'true';
        video.setAttribute('controls', '');
        video.muted = false;

        const attempt = video.play();
        if (attempt && typeof attempt.catch === 'function') {
          attempt.catch(() => {
            video.muted = true;
            const retry = video.play();
            if (retry && typeof retry.catch === 'function') {
              retry.catch(() => {
                card.dataset.playing = 'false';
                video.removeAttribute('controls');
              });
            }
          });
        }
      });
    });
  }

  function init(root) {
    if (!root || initialized.has(root)) return;
    initialized.add(root);
    initTabs(root);
    initVideoCards(root);
  }

  function initAll(scope) {
    (scope || document).querySelectorAll(SELECTOR).forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (e) => initAll(e.target));
  document.addEventListener('shopify:section:select', (e) => {
    const el = e.target && e.target.querySelector ? e.target.querySelector(SELECTOR) : null;
    if (el) init(el);
  });
})();
